import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const billing = () => import('./billing-pages');
const invoices = () => import('./invoice-pages');
const quotes = () => import('./quote-pages');
const credits = () => import('./credit-notes');
const runs = () => import('./runs-pages');

// Billing (Xero). Owned by the billing module.
export const routes: RouteObject[] = [
  {
    path: 'billing',
    lazy: page(billing, (m) => m.BillingLayout),
    children: [
      { index: true, lazy: page(billing, (m) => m.BillingDashboard) },
      { path: 'invoices', lazy: page(billing, (m) => m.InvoicesPage) },
      { path: 'credit-notes', lazy: page(credits, (m) => m.CreditNotesPage) },
      { path: 'quotes', lazy: page(billing, (m) => m.QuotesPage) },
      { path: 'runs', lazy: page(runs, (m) => m.RunsPage) },
      { path: 'receivables', lazy: page(() => import('./receivables-page'), (m) => m.AgedReceivablesPage) },
      { path: 'unbilled', lazy: page(() => import('./unbilled-page'), (m) => m.UnbilledPage) },
      { path: 'products', lazy: page(() => import('./products-page'), (m) => m.ProductsPage) },
      { path: 'expenses', lazy: page(() => import('./expenses-page'), (m) => m.ExpensesPage) },
      { path: 'settings', lazy: page(() => import('./settings-page'), (m) => m.BillingSettingsPage) },
    ],
  },
  // Documents open full width, outside the tabbed frame (as in Xero).
  { path: 'billing/invoices/new', lazy: page(invoices, (m) => m.NewInvoicePage) },
  { path: 'billing/invoices/:id', lazy: page(invoices, (m) => m.InvoiceDetailPage) },
  { path: 'billing/invoices/:id/print', lazy: page(invoices, (m) => m.InvoicePrintPage) },
  // Credit notes are invoices with kind "credit_note": they open on the invoice routes above.
  { path: 'billing/credit-notes/new', lazy: page(credits, (m) => m.NewCreditNotePage) },
  { path: 'billing/runs/:id', lazy: page(runs, (m) => m.RunReviewPage) },
  { path: 'billing/quotes/new', lazy: page(quotes, (m) => m.NewQuotePage) },
  { path: 'billing/quotes/:id', lazy: page(quotes, (m) => m.QuoteDetailPage) },
  { path: 'billing/quotes/:id/print', lazy: page(quotes, (m) => m.QuotePrintPage) },
];

export const orgRoutes: RouteObject[] = [
  { path: 'invoices', lazy: page(() => import('./org-invoices'), (m) => m.OrgInvoicesPage) },
  { path: 'quotes', lazy: page(() => import('./org-quotes'), (m) => m.OrgQuotesPage) }, // P2-3
];
